import { useEffect, useState } from "react";
import { Button, Select, Spin, Modal, Tooltip, message } from "antd";
import {
  UploadOutlined,
  DeleteOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import "@google/model-viewer/dist/model-viewer";
import { useTheme } from "./ThemeContext";
import axios from "axios";
import {
  disabledelete,
  enabledelete,
  modelDelConfirmNo,
  modelDelConfirm,
  delYesAlign,
  twinButton,
  TooltipOverlayInnerStyle
} from "../StyleObj";
import envConfig from "../config.json";
import PropTypes from 'prop-types';
import "./ViewAsset.css";
const MAPPEDMESSAGE = "This model can't be deleted as it is mapped to assets. Please remove the mappings before deleting the model.";
const POIMAPPEDMESSAGE = "This model can't be deleted as it has POI's available. Please remove the POI's before deleting the model.";
const PLANTMAPPEDMESSAGE = "This model can't be deleted as it is used in Plant Layout. Please remove the model from Layout before deleting the model.";
const DELETEVERSION = "DELETE VERSION";
const DELETEMODEL = "DELETE MODEL";
const { Option } = Select;

const ModelVersionLength = ({ deleteModelConfirm, multipleVersion }) => (
  <Button
    onClick={() => deleteModelConfirm("a")}
    disabled={!multipleVersion}
    className="viewAssetDelete"
    style={{
      color: !multipleVersion ? "#92969F" : "#FF4F59",
      border: `1px solid ${!multipleVersion ? "#92969F" : "#FF4F59"}`,
      marginRight: "5px",
      fontFamily: "Saira",
      fontStyle: "normal",
      fontSize: "12px",
      fontWeight: "700",
      lineHeight: "25px",
    }}
  >
    <span>DELETE ALL</span>
    &nbsp;
    <DeleteOutlined />
  </Button>
);


const ViewAsset = (props) => {
  const {
    handleVersion,
    versionChange,
    model,
    multipleVersion,
    gltfUrl,
    showProgress,
    curVer,
    uploadNew,

    handleCancel,
    fetchModels,
  } = props;

  ViewAsset.propTypes = {
    handleVersion: PropTypes.func,
    versionChange: PropTypes.bool,
    model: PropTypes.object,
    multipleVersion: PropTypes.bool,
    gltfUrl: PropTypes.string,
    showProgress: PropTypes.bool,
    curVer: PropTypes.object,
    uploadNew: PropTypes.func,
    deleteProgress: PropTypes.func,
    deleteDone: PropTypes.func,
    handleCancel: PropTypes.func,
    fetchModels: PropTypes.func,
  };

  const [assetUrl, setAssetUrl] = useState("");
  const [versionNo, setVersionNo] = useState();
  const [isModelDelete, setIsModelDelete] = useState(false);
  const [deleteModel, setDeleteModel] = useState("");
  const [isMapped, setIsMapped] = useState(false);
  const [isPOIMapped, setIsPOIMapped] = useState(false);
  const [isPlantMapped, setIsPlantMapped] = useState(false);
  const [deleteHoverMessage, setDeleteHoverMessage] = useState("");
  const msalToken = localStorage.getItem("msal.accesstoken");
  const { theme } = useTheme();

  const deleteButton = (
    <Button onClick={() => deleteModelConfirm("c")} style={enabledelete} className="viewAssetDelete">
      <span>DELETE</span>
      &nbsp;
      <DeleteOutlined />
    </Button>
  );

  const disableDeleteButton = (
    <Tooltip
      placement="top"
      title={deleteHoverMessage}
      overlayClassName={theme === "dark" ? "custom-tooltip-dark" : "custom-tooltip-light"}
      overlayInnerStyle={{
        ...TooltipOverlayInnerStyle(theme)
      }}
    >
      <Button disabled={true} style={disabledelete}>
        <span>DELETE</span>&nbsp;
        <DeleteOutlined style={{ color: "#ffffff" }} />
      </Button>
    </Tooltip>

  );

  const handleDeleteVersion = () => {
    props.deleteProgress();
    const selVersion = versionChange ? versionNo : curVer.number;
    const getConfig = { headers: { Authorization: `Bearer ${msalToken}` } };
    axios
      .delete(`${envConfig.aotmwapi}/api/3d-cms/content/${model._id}?mid=${selVersion}`, getConfig)
      .then((res) => {
        props.deleteDone();
        message.success({
          content: "Deleted Successfully",
          className: 'custom-message-success',
        });
        setIsModelDelete(false);
        handleCancel();
        fetchModels();
      });
  };

  const handleDelete = () => {
    props.deleteProgress();
    const getConfig = { headers: { Authorization: `Bearer ${msalToken}` } };
    axios
      .delete(`${envConfig.aotmwapi}/api/3d-cms/content/${model._id}`, getConfig)
      .then((res) => {
        props.deleteDone();
        message.success({
          content: "Deleted Successfully",
          className: 'custom-message-success',
        });
        setIsModelDelete(false);
        handleCancel();
        fetchModels();
      });
  };

  const deleteModelConfirm = (allOrCurrent) => {
    setDeleteModel(allOrCurrent);
    setIsModelDelete(true);
  };

  const isDeleteCancel = () => {
    setIsModelDelete(false);
  };

  const modelDeleteConfirm = () => {
    if (deleteModel === "a" || model.versions.length === 1) {
      handleDelete();
    } else {
      handleDeleteVersion();
    }
  };

  const asyncFilter = (arr) => {
    const results = arr.find((item) => {
      switch (item.format) {
        case "glb":
        case "gltf":
          setAssetUrl(item.url);
          return item;
        default:
          setAssetUrl("");
          return null;
      }
    });
    return results;
  };

  const handleChangeVersion = async (e) => {
    handleVersion();
    const selectedModelVersion = model.versions.find((x) => x.number === e);
    setVersionNo(selectedModelVersion.number);
    asyncFilter(selectedModelVersion.assets);
    setIsMapped(selectedModelVersion.isMapped);
    setIsPOIMapped(selectedModelVersion.isPOIMapped);
    setIsPlantMapped(selectedModelVersion.isPlantMapped);
  };

  const renderDeleteButton = () => {

    let buttonToRender;
    if (versionChange) {
      if (isMapped || isPOIMapped || isPlantMapped) {
        buttonToRender = disableDeleteButton;
      }
      else
        buttonToRender = deleteButton;
    } else {
      if (curVer?.isMapped || curVer?.isPOIMapped || curVer?.isPlantMapped) {
        buttonToRender = disableDeleteButton;
      }
      else {
        buttonToRender = deleteButton;
      }
    }

    return buttonToRender;
  };
  useEffect(() => {

    if (isMapped) {
      setDeleteHoverMessage(MAPPEDMESSAGE);
    }
    else if (isPOIMapped) {
      setDeleteHoverMessage(POIMAPPEDMESSAGE);
    }
    else if (isPlantMapped) {
      setDeleteHoverMessage(PLANTMAPPEDMESSAGE);
    }

    if (curVer?.isMapped) {
      setDeleteHoverMessage(MAPPEDMESSAGE);
    }
    else if (curVer?.isPOIMapped) {
      setDeleteHoverMessage(POIMAPPEDMESSAGE);
    }
    else if (curVer?.isPlantMapped) {
      setDeleteHoverMessage(PLANTMAPPEDMESSAGE);
    }
    renderDeleteButton();
  }, [isMapped, isPOIMapped, versionChange, props]);

  const changeDeleteTitle = () => {
    let deletetitle = DELETEVERSION;
    if (model?.versions?.length === 1 || deleteModel === "a") {
      deletetitle = DELETEMODEL;
    }
    return deletetitle;
  }

  return (
    <div>
      {!showProgress && (
        <div className="divAlignRight">
          {model.versions.length !== 1 && <ModelVersionLength deleteModelConfirm={deleteModelConfirm} multipleVersion={multipleVersion} />}
          {renderDeleteButton()}
          <Button onClick={uploadNew} className="viewButtonStyle">
            <span>UPLOAD MODEL</span>
            &nbsp;
            <UploadOutlined />
          </Button>
          <Select
            value={versionChange ? versionNo : curVer.number}
            defaultValue={curVer.number}
            className="viewButtonStyle viewAssetVersion"
            onChange={handleChangeVersion}
          >
            {model.versions?.map((m, index) => (
              <Option key={m.number} value={m.number} style={twinButton(theme)}>
                <Tooltip
                  placement="top"
                  title={`VERSION ${m.number} ${m.number === curVer.number ?"LATEST":''}`}
                  overlayClassName={theme === "dark" ? "custom-tooltip-dark" : "custom-tooltip-light"}
                  overlayInnerStyle={{
                    ...TooltipOverlayInnerStyle(theme)
                  }}
                >
                  VERSION {m.number}
                  {m.number === curVer.number && <span style={{ color: theme === "dark" ? "#01F1FF" : "#2B6FD6" }}>(LATEST)</span>}
                </Tooltip>
              </Option>
            ))}
          </Select>
          <Modal
            title={changeDeleteTitle()}
            visible={isModelDelete}
            onCancel={isDeleteCancel}
            bodyStyle={{ backgroundColor: "#262E40" }}
            centered
            footer={null}
          >
            <div className="divAlignCenter">
              <ExclamationCircleFilled
                style={{
                  color: deleteModel === "a" ? "#FBAF00" : "#FBAF00",
                  fontSize: "xx-large",
                }}
              />
            </div>
            <p className="divAlignCenter">
              Are you sure you want to delete {deleteModel === "a" ? "all versions" : "this version"}?
            </p>
            <div>
              <span>
                <Button
                  className="model-del-confirm-no"
                  style={modelDelConfirmNo}
                  onClick={isDeleteCancel}
                >
                  NO, KEEP
                </Button>
              </span>
              <span span={8} offset={8} style={delYesAlign}>
                <Button style={modelDelConfirm} onClick={modelDeleteConfirm} className="model-confirm-yes">
                  YES, DELETE
                </Button>
              </span>
            </div>
          </Modal>
        </div>
      )}


      <Spin spinning={showProgress}>
        <model-viewer
          src={versionChange ? assetUrl : gltfUrl}
          shadow-intensity="1"
          camera-controls
          auto-rotate
          ar
          class="viewAssetModel"
        ></model-viewer>
      </Spin>
    </div>
  );
};

export default ViewAsset;
